import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type {
  IMegaMenuContainerItemDefinition,
  MegaMenuContainerItemProps as PlatformProps,
} from '../MegaMenuContainerItem.types';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<
  PlatformProps,
  IMegaMenuContainerItemDefinition,
  PlatformProps
>()(['experiments'], ({ experiments }, carmiData) => {
  const isClassNameToRootEnabled = isExperimentOpen(
    experiments,
    'specs.thunderbolt.isClassNameToRootEnabledNext',
  );
  return { ...carmiData, isClassNameToRootEnabled };
});
export const css = withCompInfo()([], () => {
  return {
    '--rd': '0',
    '--brw': '0',
    '--shd': 'none',
    '--bg': 'transparent',
  };
});

export const uiType = withCompInfo<any, IMegaMenuContainerItemDefinition>()(
  ['isClassicComponent', 'skin'],
  ({ skin, isClassicComponent }) => {
    if (skin === 'Dropdown') {
      return 'Dropdown';
    }
    return isClassicComponent ? 'Classic' : 'Responsive';
  },
);

export default createComponentMapperModel({ props, css, uiType });
